module.exports = __webpack_public_path__ + "static/media/appStoreBadge.9141acd6.svg";